

































import Vue from 'vue';
import router from '../../router';

export default Vue.extend({
  name: 'Footer',
  methods: {
    toContact() {
      //router.push('/contact');

    },
  },
});
